import { ReactNode } from 'react';

export type DummyProps = {
  children: () => ReactNode;
};
/**
 * 傀儡娃娃
 * 这个是黑科技，请谨慎使用，非高级玩家不可使用
 * @returns
 */
export function Dummy({ children }: DummyProps) {
  return children();
}
